import { TextCursorInputIcon } from "lucide-react";

import { prop, define } from "@/components/builder/utils";

import BasePreview from "./base";

function InputPreview({ ...props }) {
  return <BasePreview {...props}>
    <input />
  </BasePreview>
}

export default define('input', InputPreview, 'input')
  .tag({ children: false })
  .palete(<TextCursorInputIcon size={16} />, 'Input', 'Content')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.typography())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(...prop.predefined.typography())
  .property(prop.predefined.accentColor())
  .property(prop.group('Type', 'attributes[type]').unique()
    .category('default')
    .ignoreDevice(true)
    .props({
      creatable: true,
    })
    .options(prop.options()
      .add('Text', 'text')
      .add('Radio', 'radio')
      .add('Checkbox', 'checkbox')
      .add('Password', 'password')
      .add('Email', 'email')
      .add('Number', 'number')
      .add('Telephone', 'tel')
      .add('URL', 'url')
      .add('Search', 'search')
      .add('Date', 'date')
      .add('Time', 'time')
      .add('Date and time', 'datetime-local')
      .add('Month', 'month')
      .add('Week', 'week')
      .add('Color', 'color')
      .add('File', 'file')
      .add('Hidden', 'hidden')
      .add('Image', 'image')))
  .property(prop.text('Placeholder', 'attributes[placeholder]').category('default').ignoreDevice(true))
  .property(prop.predefined.attributes().props({ hiddenAttributes: ['type', 'placeholder', 'name'] }))
  .defaultProps({
    attributes: {
      type: 'text',
      placeholder: 'Placeholder...',
    },
    content: "Input",
    rounded: { rounded: "2" },
    space: {
      padding: 'pt-2 pb-2 pl-2 pr-2',
    },
    outline: { outline: '2' },
    outlineColor: 'gray-400',
  })
  .build()

